import React from "react";
import moment from "moment";
import { TAnnex6V2Record } from "redux/app/annex6-v2/@types";
import { TAnnex6V2GroupB1 } from "redux/app/annex6-v2/groups/group-b";
import Annex6V2TableRows from "../Annex6V2TableRows";

type OwnProps = {
	annex6V2Record: TAnnex6V2Record;
	isStrikedOff?: boolean;
	theme?: "light" | "dark";
};
type Annex6V2GroupB1PreviewProps = OwnProps;

function Annex6V2GroupB1Preview(props: Annex6V2GroupB1PreviewProps) {
	const record = props.annex6V2Record as TAnnex6V2GroupB1;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<Annex6V2TableRows
				record={record}
				tableRows={[
					[operationDate, "B", "1.1", renderItemB1P1()],
					[null, null, "2", renderItemB1P2()],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	function renderItemB1P1() {
		const {
			date: smtDate,
			time: smtTime,
			latitude,
			longitude,
		} = record.itemB1P1.enteringNOXTier3;
		const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);

		return (
			<h4 className="font-medium uppercase">
				{utcTime.format("HH:mm")} hrs UTC on {utcTime.format("DD-MMM-YYYY")} (
				{smtTime} SMT on {moment(smtDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				at position {latitude} | {longitude}
			</h4>
		);
	}

	function renderItemB1P2() {
		return (
			<h4 className="font-medium uppercase">
				Status of all applicable engines and their SCR/EGR equipment:{" "}
				{record.itemB1P2.status}
			</h4>
		);
	}

	return renderMain();
}

export default Annex6V2GroupB1Preview;
